import {toast} from 'react-toastify';

export function successNotification(message)
{
    toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
}

export function errorNotification(message)
{
    toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        isMobile:true,
        breakpoint:600
        });
}

export function formSuccessNotification(message)
{
    toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
}

export function formErrorNotification(message)
{
    toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
}

export function LoadingToast(message)
{
    return toast.loading(message,{
        isLoading: true,
        hideProgressBar: true,
    });
}

export function UpdateToastSuccess(message,toastId)
{
    toast.update(toastId,{  
    render:message,     
    position: "top-right",
    type:"success",
    isLoading:false,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
   });
};

export function UpdateToastFailed(message,toastId)
{
    toast.update(toastId,{
        render:message,
        position: "top-right",
        isLoading:false,
        type:"error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    })
}